import type { QueryClient } from '@tanstack/svelte-query';
import {
	getEditionsGalleryBaseParams,
	getEditionsGalleryRestParams,
} from '../getEditionsGalleryRestParams/getEditionsGalleryRestParams';
import {
	editionsGalleryItemsQueryKey,
	getEditionsGalleryItems,
} from '#lib/websites/editions/api/getEditionsGalleryPage.js';
import { EDITIONS_GALLERY_STALE_TIME } from '#lib/websites/editions/constants/gallery.js';
import type { EditionsGalleryPageLoadEvent } from '$routes/editions/gallery/types';

export const editionsGalleryPageLoad = async ({
	parent,
	data,
	url,
	fetch,
}: EditionsGalleryPageLoadEvent) => {
	const parentData = await parent();
	const queryClient: QueryClient = parentData.queryClient;

	queryClient.setQueryData(
		editionsGalleryItemsQueryKey(getEditionsGalleryBaseParams()),
		{ pageParams: [0], pages: [data.editions] }
	);

	const params = getEditionsGalleryRestParams({
		searchParams: url.searchParams,
		filterSections: data.filterSections,
	});

	queryClient.prefetchInfiniteQuery({
		queryKey: editionsGalleryItemsQueryKey(params),
		queryFn: ({ pageParam }) =>
			getEditionsGalleryItems(fetch, {
				...params,
				offset: pageParam as number,
			}),
		initialPageParam: 0,
		staleTime: EDITIONS_GALLERY_STALE_TIME,
	});

	return {
		...parentData,
		...data,
		params,
	};
};
